/* src/app/ship/ship-options/ship-options.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.ship-options .form-section-header {
  margin-bottom: 0 !important;
}
.ship-options .help-icon {
  width: 15px;
  height: 15px;
  margin: 0 0.5em;
}
.ship-options .mat-mdc-radio-button {
  display: block;
}
.ship-options .base-align-group {
  display: flex;
  flex-direction: column;
}
.ship-options .base-radio-button {
  margin: 5px;
}
.ship-options .base-selected-value {
  margin: 15px 0;
}
.ship-options .schedule-pickup {
  margin: 1rem 0;
  padding-left: 2.35em;
}
.ship-options .schedule-pickup .return-ship-from-address {
  font-size: 0.9375rem;
  padding: 1.5em 0em;
}
.ship-options .schedule-pickup .return-ship-from-address .name {
  font-weight: 700;
}
.ship-options .schedule-pickup .return-ship-from-address .company {
  font-weight: 700;
}
.ship-options .schedule-pickup .return-ship-from-address .address {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
}
.ship-options .schedule-pickup .return-ship-from-address .address span {
  margin-right: 0.25em;
}
.ship-options .schedule-pickup .return-ship-from-address .address span:last-of-type {
  margin-right: 0;
}
.ship-options .warning-message {
  font-size: 0.8125rem;
  margin-bottom: 1em;
}
.ship-options .time-inputs {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .ship-options .time-inputs {
    flex-direction: row;
  }
}
@media screen and (min-width: 48rem) {
  .ship-options .time-inputs .time-input {
    width: 50%;
  }
  .ship-options .time-inputs .time-input:first-of-type {
    padding-right: 1em;
  }
  .ship-options .time-inputs .time-input:last-of-type {
    padding-left: 1em;
  }
}
.ship-options .return-date {
  padding: 1em 0 0 2.4em;
}
.ship-options .time-selectors {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 1.5rem;
}
.ship-options .time-selectors + .mat-mdc-form-field-error {
  margin: -1em 0 1em 0;
}
.ship-options .time-selectors .select-wrapper {
  width: 5em;
}
.ship-options .time-selectors .select-wrapper ::ng-deep {
}
.ship-options .time-selectors .select-wrapper ::ng-deep .mat-select-placeholder {
  white-space: nowrap;
}
.ship-options .time-selectors .select-wrapper ::ng-deep .mat-select-trigger {
  min-width: 0;
}
.ship-options .time-selectors .select-wrapper ::ng-deep .mat-select-trigger .mat-select-value {
  width: 100%;
  text-align: center;
}
.ship-options .time-selectors .connector {
  margin: 0 0.25em;
}
.ship-options .time-selectors .period {
  margin: 0 0.25em;
}
.date-input .mat-mdc-input-element {
  visibility: hidden;
  height: 0;
}
.date-input .formatted-date {
  font-size: 0.9em;
  display: inline-block;
  width: 100%;
  position: absolute;
  top: 0.7em;
  left: 0;
}
.option-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
/*# sourceMappingURL=ship-options.component.css.map */
